    <div class="d-flex">
      <span class=" d-block mb-2 subtitle-1--weight-regular">Recent Donations</span>
      <a
        *ngIf="showSeeAll$ | async"
        type="button" 
        class="subtitle-1--weight-regular ml-auto"
        style="
        cursor: pointer;
        color: #007bff;
        font-size: 12px;
        "
        (click)="onAllDonationsClick()">
        See All
      </a>
    </div>
      <ng-container *ngIf="recentDonation$ | async as donations">
        <table *ngIf="showRecentDonation" class="table mb-1 table-sm table-dashboard--paybee">
          <thead>
            <tr>
              <th scope="col" style="min-width: 125px;">DONOR</th>
              <th scope="col">CAMPAIGN</th>
              <th scope="col" style="min-width: 80px;">AMOUNT</th>
              <th scope="col"></th>  
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let donation of donations;let i = index;">
              <td>{{donation.payer.name}}</td>
              <td>{{donation.campaignName}}</td>
              <td>{{getAmount(donation.amount)}}</td>
              <td >{{ donation.date | async | activityTimer:i }}</td>
            </tr>
          </tbody>    
        </table>
      </ng-container>
      <span *ngIf="!showRecentDonation" style="font-size: 12px;color:#7c8187">No activity yet!</span>

